import React, { Fragment } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import AccountView from '../Components/Account/settings'
import Leftbar from '../Components/Sidebar/Leftbar'

function Account() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          marginLeft: 24,
          marginTop: 24,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <SHeaderbar />
        <div style={{ flex: 1, padding: 0, minHeight: 0 }}>
          <AccountView />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}
export default Account
